import { render, staticRenderFns } from "./ModalRecoverTask.vue?vue&type=template&id=f715501c"
import script from "./ModalRecoverTask.vue?vue&type=script&lang=js"
export * from "./ModalRecoverTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports